import { Factory } from 'fishery';
import { SearchClientsResponse } from './ClientServices.types';

export const ClientFactory = Factory.define<SearchClientsResponse['results'][0]>(
  ({ sequence }) => ({
    guid: sequence.toString(),
    email: 'email@email.com',
    isActive: true,
    mobileNumber: null,
    name: 'Client',
    phoneNumber: null,
    website: null,
  }),
);

export const ClientSearchFactory = Factory.define<SearchClientsResponse>(() => ({
  next: false,
  page: 0,
  results: ClientFactory.buildList(5),
  rows: 5,
}));
